/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_HighlightInputs */

const et_plan_website_highlight = /** @type {(inputs: Plan_Website_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugev esmamulje`)
};

const en_plan_website_highlight = /** @type {(inputs: Plan_Website_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong first impression`)
};

/**
* | output |
* | --- |
* | "Strong first impression" |
*
* @param {Plan_Website_HighlightInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_highlight = /** @type {((inputs?: Plan_Website_HighlightInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_HighlightInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_highlight(inputs)
	return en_plan_website_highlight(inputs)
});